export default __webpack_public_path__ + "static/media/PortadaRestaurante.3e732ece.jpg";